import { useAtomValue } from 'jotai';

import { leadIdAtom } from '../atoms';

export const useLeadIdValue = () => useAtomValue(leadIdAtom);
